<template>
    <div class="account" :class="isScroll?'':'isBackground'">
        <div class="header">
            <img @click="back" class="close" src="@/assets/images/template/a_top_close.png"/>
            <div class="country">
                <div class="showCity"><img @click="openIM" src="@/assets/images/template/nav_float_live800.png"/><em :class="{vn:cityClass}" @click="showCity"></em><p @click="showCity"></p></div>
                <div class="hideCity" v-if="isCity">
                    <ul>
                        <li @click="checkCity('en')"><img src="@/assets/images/template/pic_language_en.png"/><span>EN</span></li>
                        <li @click="checkCity('vn')"><img src="@/assets/images/template/pic_language_vn.png"/><span>VN</span></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="circle"><span :class="{vn:cityClass}"></span></div>
        <div class="formBox">
            <form>
                <div class="item"><input :placeholder="$t('login.account')"></div>
                <div class="errMessage"><span></span></div>
                <div class="item pw">
                    <input :placeholder="$t('login.password')">
                    <div class="itemSave" :class="{save:isSavePw}" @click="savePw"><em></em><span>Save</span></div>
                </div>
                <div class="errMessage"><span></span></div>
                <div class="item"><a>{{$t('login.submit')}}</a></div>
            </form>
        </div>
        <div class="optBox"><span>{{$t('login.forget')}}？</span></div>
        <div class="quickLogin">
            <div class="title"><em></em><span>or log in via</span></div>
            <div class="conList">
                <ul>
                    <li><img src="@/assets/images/account/login_denglufangshi_1.png"/></li>
                    <li><img src="@/assets/images/account/login_denglufangshi_2.png"/></li>
                    <li><img src="@/assets/images/account/login_denglufangshi_3.png"/></li>
                </ul>
            </div>
        </div>
        <div class="optBox center"><span>No account yet?<a>Register Now</a></span></div>
    </div>
</template>

<script>
    require('@/assets/css/account.css');
    import {mapState} from 'vuex'
    export default {
        name: "Account",
        computed: {
            ...mapState(['locale'])
        },
        data() {
            return {
                isCity: false,
                cityClass: false,
                isSavePw: false,
                isScroll: '',
                lang:''
            }
        },
        methods: {
            hasScrollbar() {
                if (document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight)) {
                    this.isScroll = true;
                } else this.isScroll = false;
                return this.isScroll
            },
            back() {
                this.$router.go(-1);
            },
            openIM() {
                var url = `https://onlinecs.cfglobal139.com/?lang=${this.locale}&version=vntrex&company_id=30&utm_source=web&utm_terminal=1&refer=https%3A%2F%2Fwww.cfglobal139.com%2F${this.locale}%2F`
                var left = (screen.width / 2) - (800 / 2);
                var top = (screen.height / 2) - (550 / 2);
                window.open(url, "DescriptiveWindowName", "resizable,scrollbars=yes,status=1,width=800, height=550, top=" + top + ", left=" + left);
            },
            showCity() {
                this.isCity = !this.isCity
            },
            checkCity(city) {
                if (city == "en") {
                    this.cityClass = false;
                    this.localeCity = 'en';
                } else if (city == "vn") {
                    this.cityClass = !this.cityClass;
                    this.localeCity = 'vn';
                }
                this.$i18n.locale = this.localeCity;
                this.$store.dispatch('setLocale', this.localeCity);
                this.isCity = false
            },
            savePw() {
                this.isSavePw = !this.isSavePw
            }
        },
        mounted() {
            this.$bus.$emit('loading', true);
            window.scrollTo(0, 0);
            this.hasScrollbar();
            let main = document.getElementById("main");
            main.style.paddingBottom = 0;
            main.style.marginBottom = 0;
        },
        activated() {
            this.$bus.$emit('loading', true);
            window.scrollTo(0, 0);
            this.hasScrollbar();
            let main = document.getElementById("main");
            main.style.paddingBottom = 0;
            main.style.marginBottom = 0;
        },
    }
</script>